import { styled } from '@clickcease/cc-client-components-lib'

export const LoaderContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '600px',
})

export const OnboardingPage = styled('div', {
  background: '$white',
  boxShadow: '0px 4px 20px rgba(102, 102, 102, 0.08)',
  height: '100%',
  borderRadius: '$medium',
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  overflow: 'auto',
})

export const OnboardingContainerStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  border: '$veryLightNeutral 1px solid',
  borderRadius: '$medium',
})

export const TitleContainer = styled('div', {
  padding: '$8 $12',
  borderBottom: '$veryLightNeutral 1px solid',
})

export const StepsContainer = styled('div', {
  padding: '$12',
})
